export default __webpack_public_path__ + "static/media/Realme_Five.3f676b4c.png";